import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=3f96aaba&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=3f96aaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96aaba",
  null
  
)

export default component.exports